(() => {
  function initReviewSection(section) {
    if (!section || section.dataset.fxsReviewReady === 'true') return;
    section.dataset.fxsReviewReady = 'true';

    const track = section.querySelector('[data-fxs-review-track]');
    const prev = section.querySelector('[data-fxs-review-prev]');
    const next = section.querySelector('[data-fxs-review-next]');
    if (!track) return;

    const originalCards = Array.from(track.children);
    if (originalCards.length < 2) {
      prev?.setAttribute('disabled', 'disabled');
      next?.setAttribute('disabled', 'disabled');
      return;
    }

    const prepareClone = (card) => {
      const clone = card.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.dataset.fxsReviewClone = 'true';

      clone.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
      clone.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach((element) => {
        element.setAttribute('tabindex', '-1');
      });

      if ('inert' in clone) clone.inert = true;
      return clone;
    };

    const beforeFragment = document.createDocumentFragment();
    const afterFragment = document.createDocumentFragment();

    originalCards.forEach((card) => {
      beforeFragment.appendChild(prepareClone(card));
      afterFragment.appendChild(prepareClone(card));
    });

    track.prepend(beforeFragment);
    track.append(afterFragment);

    const allCards = Array.from(track.children);
    const originalStartIndex = originalCards.length;
    const afterStartIndex = originalCards.length * 2;

    const getOriginalStart = () => allCards[originalStartIndex]?.offsetLeft || 0;
    const getAfterStart = () => allCards[afterStartIndex]?.offsetLeft || track.scrollWidth;
    const getSetWidth = () => getAfterStart() - getOriginalStart();

    const getCardStep = () => {
      const first = originalCards[0];
      const second = originalCards[1];
      if (first && second) return Math.max(1, second.offsetLeft - first.offsetLeft);

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return Math.max(1, (first?.getBoundingClientRect().width || 280) + gap);
    };

    const jumpToOriginalSet = () => {
      track.scrollTo({ left: getOriginalStart(), behavior: 'auto' });
    };

    requestAnimationFrame(jumpToOriginalSet);

    let resetTimer;

    const normalizePosition = () => {
      window.clearTimeout(resetTimer);
      resetTimer = window.setTimeout(() => {
        const originalStart = getOriginalStart();
        const afterStart = getAfterStart();
        const setWidth = getSetWidth();
        const threshold = getCardStep() * 0.5;

        if (setWidth <= 0) return;

        if (track.scrollLeft < originalStart - threshold) {
          track.scrollTo({
            left: track.scrollLeft + setWidth,
            behavior: 'auto'
          });
        } else if (track.scrollLeft >= afterStart - threshold) {
          track.scrollTo({
            left: track.scrollLeft - setWidth,
            behavior: 'auto'
          });
        }
      }, 90);
    };

    track.addEventListener('scroll', normalizePosition, { passive: true });

    const move = (direction) => {
      track.scrollBy({
        left: direction * getCardStep(),
        behavior: 'smooth'
      });
    };

    prev?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));

    window.addEventListener('resize', () => {
      window.clearTimeout(resetTimer);
      resetTimer = window.setTimeout(jumpToOriginalSet, 120);
    });
  }

  function initFaq(section) {
    if (!section || section.dataset.fxsFaqReady === 'true') return;
    section.dataset.fxsFaqReady = 'true';

    const columns = Array.from(section.querySelectorAll('[data-fxs-faq-column]'));
    columns.forEach((column) => {
      const items = Array.from(column.querySelectorAll('details'));
      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;
          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });
    });
  }

  function initPurchaseButtons(container = document) {
    container.querySelectorAll('[data-fx-add-current-product]').forEach((button) => {
      if (button.dataset.fxPurchaseReady === 'true') return;
      button.dataset.fxPurchaseReady = 'true';

      button.addEventListener('click', () => {
        const hero = document.querySelector('[data-fx-product]');
        const addButton = hero?.querySelector('[data-add-to-cart]');
        if (addButton && !addButton.disabled) {
          addButton.click();
          return;
        }
        hero?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  function init(container = document) {
    container.querySelectorAll('[data-fxs-review-section]').forEach(initReviewSection);
    container.querySelectorAll('[data-fxs-faq]').forEach(initFaq);
    initPurchaseButtons(container);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
